/**
 * 캐시 출금 확인 창 (/adm/account/review?num=…) — 좌: 기사관리, 우: 회원 앱(대리로그인), 아래: 신청 정보·메모·완료/취소
 * ($j.Pages.Admin.AccountReview / body data-page-name="AccountReview")
 *
 * 레이아웃 없이 그려지는 단독 문서다. 신청건(row)·계좌(r)는 #page-data.
 */
let row = {};
let r = {};

export default class AccountReview {
    initialize() {
        const d = JSON.parse(document.getElementById('page-data').textContent);
        row = d.row;
        r = d.r;
        initialize();
    }
}

function initialize() {
    // 모바일 세션은 브라우저에 하나라, 다른 창에서 대리로그인하면 우측창이 그 회원으로 바뀐다.
    // 이 창으로 돌아올 때마다 우측창을 다시 대리로그인해 이 신청건 회원으로 되돌린다.
    // focus 이벤트 대신 hasFocus 를 본다 — 창 안의 iframe 을 오갈 때는 다시 부르지 않고,
    // 포커스가 iframe 안에 있다가 다른 창으로 나갔다 와도 잡힌다.
    (function () {
        const pane = document.getElementById('mobilePane');
        const src  = pane.src;
        let had = document.hasFocus();
        setInterval(function () {
            const has = document.hasFocus();
            if (has && !had) pane.src = src;
            had = has;
        }, 500);
    })();

    // 계좌번호만 클립보드에 복사
    $('#copyAccountBtn').on('click', function(){
        const $textarea = $('<textarea>').val(r.account).appendTo('body');
        $textarea.get(0).select();
        $textarea.get(0).setSelectionRange(0, 99999); // 모바일 지원
        document.execCommand('copy');
        $textarea.remove();
        alert('계좌번호가 복사되었습니다');
    });

    $('#confirmBtn').on('click', function(){
        $j.Common.Util.swalert(['출금 완료로 변경하시겠습니까?', 'question'],()=>{
            changeStatus('complete')
        },['네','아니오'])
    });
    $('#cancleBtn').on('click', function(){
        $j.Common.Util.swalert(['출금 취소로 변경하시겠습니까?', 'question'],()=>{
            changeStatus('cancel')
        },['네','아니오'])
    });
}

/**
 * 상태 변경시
 * @param action 변할 상태
 */
function changeStatus(action) {
    const memo = $('#memo').val();
    let arr = {
        action: action,
        num: row.num,
        mb_no: row.mb_no,
        amount: row.amount,
        memo: memo,
    };

    $.ajax({
        url: '/adm/ajax/account/update',
        type: 'POST',
        data: arr,
        success: function (response) {
            // 성공적으로 처리된 경우
            if (response.success) {
                alert('상태가 성공적으로 변경되었습니다.');
                $('.btn_box').hide();
                if (window.opener) {
                    window.opener.location.reload(); // 부모 페이지 새로고침
                }
                window.location.reload();
            } else {
                // 출금금지 명단 등 서버가 사유를 내려주면 그대로 보여준다
                alert(response.message || '새로고침하여 상태를 다시 확인해주세요');
            }
        }
    });
}
